import './style/normalize.css'
import './style/Colours.css'
import './style/Page_Layout.css'
import './style/Text.css'
import './style/App.css'
import './style/User_Advice.css'
import './style/Checkbox.css'
import '../Components/Toggle.css'
import {Splash_Page} from '../Splash_Page/Splash_Page'
import {
	Client_State_Name,
} from '@quiz-buzz/client-common'
import {Error_Boundary} from './Error_Boundary'
import { Toaster } from 'react-hot-toast'
import '../Help_Tips/Help_Tips.css'
import { app_version, app_version_hash } from '@quiz-buzz/common'
import { style } from 'typestyle'
import { useSelector } from '@xstate/react';
import { host_machine_actor, player_machine_actor } from './main'
import { Player_Mode_Content } from './Player_Mode_Content'
import Host_Mode_Content from './Host_Mode_Content'
import { Host_State_Name } from '@quiz-buzz/client-common/src/State/Host_State_Machine'


export function App() {

	const player_state_name = useSelector(player_machine_actor, (state) => state.value)
	const host_state_name = useSelector(host_machine_actor, (state) => state.value)
	const player_is_waiting = useSelector(player_machine_actor, (state) => state.context.awaiting_server_response)
	const host_is_waiting = useSelector(host_machine_actor, (state) => state.context.awaiting_server_response)

	let app_mode = 'splash'
	const show_loading_indicator = app_mode !== 'splash' && (player_is_waiting || host_is_waiting)

	if (host_state_name !== Host_State_Name.splash) {
		app_mode = 'host'
	}
	else if (player_state_name !== Client_State_Name.splash) {
		app_mode = 'player'
	}

	return (
		<div className={app_root_style}>
			<div className="background_image">
				<div className="background_shade">
					<div className={app_style} data-help-tips-base="base">
						<Error_Boundary>
							{show_loading_indicator && (
								<div className="loading_indicator" role="status" aria-live="polite" aria-label="Loading">
									<div className="loading_spinner" />
									<div>Loading...</div>
								</div>
							)}
							{ app_mode === 'splash' && <Splash_Page />}
							{ app_mode === 'player' && <Player_Mode_Content />}
							{ app_mode === 'host' && <Host_Mode_Content />}
							
							<Toaster position="bottom-center" />
							<div id="app-version" className={app_version_style} onClick={show_version}>
								<div>App Version: {app_version}</div>
								<div>App Hash: {app_version_hash}</div>
							</div>
						</Error_Boundary>
					</div>
				</div>
			</div>
		</div>
	)
}

export default App

const show_version = () => {
	(document.querySelector('#app-version') as HTMLDivElement).style.color = "white"
	window.setTimeout(() => {
		(document.querySelector('#app-version') as HTMLDivElement).style.color = "#00000000";
	}, 800)
}

const app_root_style = style({
	margin: '0 auto',
	maxWidth: '30rem',
	height: '100%',
	position: 'relative',
})

const app_style = style({
	position: 'relative',
	height: '100%',
	width: '100%',
	overflow: 'hidden',
})

const app_version_style = style({
	color: '#00000000',
	position: 'absolute',
	top: '0',
	right: '0',
	fontSize: '0.6em',
})
